export default "__VITE_ASSET__SZxDlh7Y__"